"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONSTANTS = {
  INPUT_ADDON_MAX_ALLOWED_CHARACTERS: 18
};

exports.default = CONSTANTS;